import dayjs from 'dayjs'

type DateFieldNames =
  | 'startDate'
  | 'endDate'
  | 'dateOfReportGeneration'
  | 'dateOfReportReview'

interface CalibrationVerification {
  date: string | null
  [key: string]: unknown
}

interface DataWithDates {
  [key: string]: unknown
  calibrationVerification?: CalibrationVerification[]
}

export const convertDatesToDay = (
  data: Record<string, unknown>
): DataWithDates => {
  const dateFields: DateFieldNames[] = [
    'startDate',
    'endDate',
    'dateOfReportGeneration',
    'dateOfReportReview',
  ]

  const converted = { ...data }
  for (const field of dateFields) {
    if (converted[field] && typeof converted[field] === 'string') {
      converted[field] = dayjs(converted[field] as string)
    }
  }

  // Handle nested date arrays if needed
  if (
    Array.isArray(converted.calibrationVerification) &&
    converted.calibrationVerification.length > 0
  ) {
    converted.calibrationVerification = converted.calibrationVerification.map(
      (verification: CalibrationVerification) => ({
        ...verification,
        date: verification.date ? dayjs(verification.date) : null,
      })
    )
  }

  return converted as DataWithDates
}
